import React from 'react';

const Cross = () => {
    return (
        <svg width={8} height={7.999} viewBox="0 0 8 7.999">
            <path
                d="M4.939 3.999l2.867-2.857A.669.669 0 106.86.196L4 3.06 1.143.196a.669.669 0 10-.946.946l2.864 2.857L.197 6.856a.669.669 0 10.946.946L4 4.938l2.857 2.866a.669.669 0 10.946-.946z"
                fill="#000946"
            />
        </svg>
    );
};

export default Cross;
